import TextInput from './FormElements/TextInput'
import {Fragment, useCallback, useEffect, useState} from 'react'
import MultipleChoiceInput from './FormElements/MultipleChoiceInput'
import CheckBoxesInput from './FormElements/CheckBoxesInput'
import DropdownInput from './FormElements/DropdownInput'
import ToggleButton from './FormElements/ToggleButton'
import {KTIcon} from '../../../../_metronic/helpers'
import ToggleButton2 from './FormElements/ToggleButton2'
import {getInterviewbyid, getProject, updateInterview} from '../_requets'
import {useNavigate, useParams} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
import {RootState} from '../../../redux/store'
import {setProjects} from '../../../redux/project/projectSlice'
import {editInterview} from '../../../redux/interview/interviewSlice'
import Swal from 'sweetalert2'
import toast from 'react-hot-toast'
import Select from 'react-select'
import MultipleChoiceSectionInput from './FormElements/MultipleChoiceSectionInput'
import PreferenceInput, {PreferenceOptions} from './FormElements/PreferenceInput'
import {FormDataType} from './InterviewFormBuilder'

const InterviewEditForm = () => {
  const [groupOption, setGroupOption] = useState<any>()
  const dispatch = useDispatch()
  const projectList = useSelector((state: RootState) => state.project.projects)
  const loading = useSelector((state: RootState) => state.project.loading)
  const [surveyorList, setSurveyorList] = useState(0)
  const [surveyorData, setSurveyorData] = useState([])
  const [clientsData, setClientsData] = useState([])
  const [selectedGroup, setSelectedGroup] = useState<any>()
  const [selectedAgents, setSelectedAgents] = useState(null)
  const [selectedAgentValues, setSelectedAgentValues] = useState([])

  const [selectedClients, setSelectedClients] = useState(null)
  const [selectedClientValues, setSelectedClientValues] = useState([])

  const [checkpoints, setCheckpoints] = useState([])
  const MAX_CHECKPOINTS = 3

  const [formData, setFormData] = useState<FormDataType[]>([
    {
      title: '',
      titleId: '',
      questionId: '',
      order: 0,
      question: '',
      type: 'text',
      required: false,
      other: false,
      options: [''],
      comment: false,
      subquestions: [],
      showSubQuestion: false,
      reason: false,
      reasonTitle: '',
      reasonId: '',
      reasonType: 'text',
      reasonOptions: [''],
      checkpointId: null,
      preferenceOptions: [
        {
          title: '',
          icon: 'car',
          fuel: 0,
          fare: 0,
          tolls: 0,
          parking: 0,
          toFrom: '',
          timeToTravel: '',
          totalCost: 0,
          totalTime: '',
        },
      ],
    },
  ])

  const [interviewData, setInterviewData] = useState({
    interviewName: '',
    project: '',
    group: '',
    questionnaireUI: 'default',
  })
  const params = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    const getlist = async () => {
      const res = await getProject()
      const data = res.map((item, index) => {
        return item.agent
      })
      setSurveyorData(data)
      const temp = res.map((item, index) => {
        return item.clients
      })
      setClientsData(temp)
      dispatch(setProjects(res))
    }
    if (loading) getlist()
    else {
      const data = projectList.map((item, index) => {
        return item.agent
      })
      setSurveyorData(data)
      const temp = projectList.map((item, index) => {
        return item.clients
      })
      setClientsData(temp)
    }

    const fetchData = async () => {
      const res = await getInterviewbyid(params.id)

      // Transform the flat questions structure back to the form structure with subquestions
      const groupedQuestions = []
      const questionMap = new Map()

      res.questions.forEach((question) => {
        if (question.title && question.title.trim() !== '') {
          // This is a subquestion
          if (!questionMap.has(question.title)) {
            questionMap.set(question.title, {
              title: question.title,
              titleId: question?.titleId || '',
              questionId: question?.questionId || '',
              order: question.order,
              question: '',
              type: 'text',
              required: false,
              other: false,
              options: [''],
              comment: false,
              subquestions: [],
              showSubQuestion: true,
              reasonTitle: '',
              reasonId: question.reasonId || '',
              reason: false,
              reasonType: 'text',
              reasonOptions: [''],
              preferenceOptions: question?.preferenceOptions || [],
            })
          }
          questionMap.get(question.title).subquestions.push({
            question: question.question,
            titleId: question?.titleId || '',
            questionId: question?.questionId || '',
            type: question.type,
            required: question.required || false,
            other: question.other || false,
            options: question.options || [''],
            comment: question.comment || false,
            reason: question.reason || false,
            reasonTitle: question.reasonTitle || '',
            reasonId: question.reasonId || '',
            reasonType: question.reasonType || 'text',
            reasonOptions: question.reasonOptions || [''],
            preferenceOptions: question?.preferenceOptions || [],
          })
        } else {
          // This is a main question
          groupedQuestions.push({
            title: question.title || '',
            titleId: question?.titleId || '',
            questionId: question?.questionId || '',
            order: question.order,
            question: question.question,
            type: question.type,
            required: question.required || false,
            other: question.other || false,
            options: question.options || [''],
            comment: question.comment || false,
            subquestions: [],
            showSubQuestion: false,
            reason: question.reason || false,
            reasonTitle: question.reasonTitle || '',
            reasonId: question.reasonId || '',
            reasonType: question.reasonType || 'text',
            reasonOptions: question.reasonOptions || [''],
            preferenceOptions: question?.preferenceOptions || [],
          })
        }
      })

      // Add subquestion groups to the main array
      questionMap.forEach((group) => {
        groupedQuestions.push(group)
      })

      // Sort by order
      groupedQuestions.sort((a, b) => a.order - b.order)

      setFormData(
        groupedQuestions.length > 0
          ? groupedQuestions
          : [
              {
                title: '',
                titleId: '',
                questionId: '',
                order: 0,
                question: '',
                type: 'text',
                required: false,
                other: false,
                options: [''],
                comment: false,
                subquestions: [],
                showSubQuestion: false,
                reason: false,
                reasonTitle: '',
                reasonId: '',
                reasonType: 'text',
                reasonOptions: [''],
              },
            ]
      )

      setInterviewData({
        interviewName: res.interviewName,
        project: res.project._id,
        group: res?.group,
        questionnaireUI: res?.questionnaireUI || 'default',
      })

      const projectIndex = projectList.findIndex((item) => item._id === res.project._id)
      setSurveyorList(projectIndex)

      setCheckpoints(res?.checkpoints || [])

      setSelectedAgentValues(res?.surveyors)
      setSelectedAgents(res?.surveyors?.map((item) => ({value: item, label: item})))

      setSelectedClientValues(res?.clients)
      setSelectedClients(res?.clients?.map((item) => ({value: item, label: item})))

      setSelectedGroup(res.group)
    }
    fetchData()
  }, [params.id])

  useEffect(() => {
    const filteredList = projectList.filter((item) => item._id === interviewData.project)
    setGroupOption(filteredList[0]?.group)
  }, [interviewData, projectList])

  const updateFormData = useCallback((index: number, newData: Partial<typeof formData[0]>) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {...updatedFormData[index], ...newData}
      return updatedFormData
    })
  }, [])

  const handleInputChange = (index: number, field: string, value: any) => {
    updateFormData(index, {[field]: value})
  }

  const handleSubQuestionInputChange = (
    index: number,
    elementIndex: number,
    field: string,
    value: any
  ) => {
    const updatedFormData = [...formData]
    updatedFormData[index].subquestions[elementIndex] = {
      ...updatedFormData[index].subquestions[elementIndex],
      [field]: value,
    }
    setFormData(updatedFormData)
  }

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (
      interviewData.interviewName.length < 3 ||
      interviewData.project.length < 1 ||
      selectedAgentValues.length < 1
    ) {
      toast.error('Please fill all the fields')
      return
    }
    let formValid = true
    formData.forEach((item, idx) => {
      if (!item.showSubQuestion) {
        // Validate main question - question field is required in schema
        if (!item.question || item.question.trim().length < 3) {
          formValid = false
        }
        if (
          item.type !== 'text' &&
          item.type !== 'number' &&
          item.type !== 'date' &&
          item.type !== 'country' &&
          item.type !== 'location' &&
          !item.type?.includes('time')
        ) {
          if (item.type !== 'preference' && (!item.options || item.options.length === 0)) {
            const checkpointData = checkpoints.find((cp) => cp.index === idx)
            if (item.type === 'checkpoint' && checkpointData) {
              checkpointData.sectionOptions.forEach((option) => {
                if (!option.option || option.option.trim().length < 3) {
                  formValid = false
                }
                if (!option.from || !option.to || option.from > option.to) {
                  formValid = false
                }
              })
            } else {
              formValid = false
            }
          } else if (item.type === 'preference') {
            item.preferenceOptions.forEach((elem) => {
              if (!elem || elem.title?.trim().length < 1) {
                formValid = false
              }
            })
          } else {
            item.options.forEach((elem) => {
              if (!elem || elem.trim().length < 1) {
                formValid = false
              }
            })
          }
        }
        if (item.reason) {
          if (
            item.reasonType !== 'text' &&
            item.reasonType !== 'number' &&
            item.reasonType !== 'date' &&
            item.reasonType !== 'country' &&
            item.reasonType !== 'location' &&
            !item.reasonType?.includes('time')
          ) {
            if (!item.reasonOptions || item.reasonOptions.length === 0) {
              formValid = false
            } else {
              item.reasonOptions.forEach((elem) => {
                if (!elem || elem.trim().length < 1) {
                  formValid = false
                }
              })
            }
          }
        }
      } else {
        // Validate title for subquestion groups
        if (!item.title || item.title.trim() === '') {
          formValid = false
        }
        // Validate each subquestion
        if (!item.subquestions || item.subquestions.length === 0) {
          formValid = false
        } else {
          item.subquestions.forEach((subquestion) => {
            // Question field is required in schema
            if (!subquestion.question || subquestion.question.trim() === '') {
              formValid = false
            }
            // Type field is required in schema
            if (!subquestion.type) {
              formValid = false
            }
            // Validate options for non-text field types
            if (
              subquestion.type !== 'text' &&
              subquestion.type !== 'number' &&
              subquestion.type !== 'date' &&
              subquestion.type !== 'country' &&
              subquestion.type !== 'location' &&
              !subquestion.type?.includes('time')
            ) {
              if (!subquestion.options || subquestion.options.length === 0) {
                formValid = false
              } else {
                subquestion.options.forEach((elem) => {
                  if (!elem || elem.trim().length < 1) {
                    formValid = false
                  }
                })
              }
            }
            if (subquestion.reason) {
              if (
                subquestion.reasonType !== 'text' &&
                subquestion.reasonType !== 'number' &&
                subquestion.reasonType !== 'date' &&
                subquestion.reasonType !== 'country' &&
                subquestion.reasonType !== 'location' &&
                !subquestion.reasonType?.includes('time')
              ) {
                if (!subquestion.reasonOptions || subquestion.reasonOptions.length === 0) {
                  formValid = false
                } else {
                  subquestion.reasonOptions.forEach((elem) => {
                    if (!elem || elem.trim().length < 1) {
                      formValid = false
                    }
                  })
                }
              }
            }
          })
        }
      }
    })

    if (formValid) {
      let order = 1
      const formattedQuestions = formData.reduce((acc, item) => {
        if (!item.showSubQuestion) {
          // Single question - map to schema format
          const questionData = {
            title: item.title || undefined, // Optional field in schema
            titleId: item.titleId || item.questionId || '',
            questionId: item.questionId || '',
            order: order++,
            question: item.question,
            type: item.type,
            required: item.required || false,
            other: item.other || false,
            comment: item.comment || false,
            options:
              item.options && item.options.length > 0
                ? item.options.filter((opt) => opt && opt.trim().length > 0)
                : [],
            reason: item.reason || false,
            reasonTitle: item.reasonTitle,
            reasonId: item.reasonId || '',
            reasonType: item.reasonType,
            reasonOptions:
              item.reason && item.reasonOptions && item.reasonOptions.length > 0
                ? item.reasonOptions.filter((opt) => opt && opt.trim().length > 0)
                : [],
            checkpointId: item.checkpointId || undefined,
            preferenceOptions: item.preferenceOptions || [],
          }
          return [...acc, questionData]
        } else {
          // Subquestions - flatten and add title to each
          const subQuestionData =
            item.subquestions?.map((subquestion) => ({
              title: item.title, // Use parent title for each subquestion
              titleId: item.titleId || item.title || '',
              questionId: subquestion.questionId || '',
              order: order,
              question: subquestion.question,
              type: subquestion.type,
              required: subquestion.required || false,
              other: subquestion.other || false,
              comment: subquestion.comment || false,
              options:
                subquestion.options && subquestion.options.length > 0
                  ? subquestion.options.filter((opt) => opt && opt.trim().length > 0)
                  : [],
              reason: subquestion.reason || false,
              reasonTitle: subquestion.reasonTitle,
              reasonId: subquestion.reasonId || '',
              reasonType: subquestion.reasonType,
              reasonOptions:
                subquestion.reason &&
                subquestion.reasonOptions &&
                subquestion.reasonOptions.length > 0
                  ? subquestion.reasonOptions.filter((opt) => opt && opt.trim().length > 0)
                  : [],
              checkpointId: subquestion.checkpointId || undefined,
            })) || []
          order++
          return [...acc, ...subQuestionData]
        }
      }, [])

      const data = {
        // Array of strings
        ...interviewData,
        questions: formattedQuestions,
        surveyors: selectedAgentValues,
        clients: selectedClientValues,
        checkpoints: checkpoints,
      }
      const res = await updateInterview(data, params.id)
      if (res) {
        dispatch(editInterview(res))
        navigate(-1)
      }
    } else {
      toast.error('Please check the options and try again')
    }
  }

  const handleRequiredButton = (index: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        required: !updatedFormData[index].required,
      }
      return updatedFormData
    })
  }

  const handleSubQuestionRequiredButton = (index: number, elementIndex: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      const subquestion = updatedFormData[index].subquestions[elementIndex]
      updatedFormData[index].subquestions[elementIndex] = {
        ...subquestion,
        required: !subquestion.required,
      }
      return updatedFormData
    })
  }

  const handleCommentRequiredButton = (index: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        comment: !updatedFormData[index].comment,
      }
      return updatedFormData
    })
  }

  const handleReasonRequiredButton = (index: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        reason: !updatedFormData[index].reason,
      }
      return updatedFormData
    })
  }

  const handleSubQuestionCommentRequiredButton = (index: number, elementIndex: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      const subquestion = updatedFormData[index].subquestions[elementIndex]
      updatedFormData[index].subquestions[elementIndex] = {
        ...subquestion,
        comment: !subquestion.comment,
      }
      return updatedFormData
    })
  }

  const handleSubQuestionReasonRequiredButton = (index: number, elementIndex: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      const subquestion = updatedFormData[index].subquestions[elementIndex]
      updatedFormData[index].subquestions[elementIndex] = {
        ...subquestion,
        reason: !subquestion.reason,
      }
      return updatedFormData
    })
  }

  const handleAddSubQuestion = (index: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        subquestions: [
          {
            question: '',
            type: updatedFormData[index].subquestions?.[0]?.type === 'rank' ? 'rank' : 'text',
            required: false,
            other: false,
            options: [''],
            comment: false,
            reason: false,
            reasonTitle: '',
            reasonType: 'text',
            reasonOptions: [''],
          },
        ],
        showSubQuestion: true,
      }
      return updatedFormData
    })
  }

  const handleOtherInputButton = (index: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        other: !updatedFormData[index].other,
      }
      return updatedFormData
    })
  }

  const handleSubQuestionOtherInputButton = (index: number, elementIndex: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      const subquestion = updatedFormData[index].subquestions[elementIndex]
      updatedFormData[index].subquestions[elementIndex] = {
        ...subquestion,
        other: !subquestion.other,
      }
      return updatedFormData
    })
  }

  const handleAddQuestion = () => {
    setFormData((prev) => [
      ...prev,
      {
        title: '',
        titleId: '',
        questionId: '',
        order: prev.length,
        question: '',
        type: 'text',
        required: false,
        other: false,
        options: [''],
        comment: false,
        subquestions: [],
        showSubQuestion: false,
        reason: false,
        reasonTitle: '',
        reasonId: '',
        reasonType: 'text',
        reasonOptions: [''],
        checkpointId: null,
        preferenceOptions: [
          {
            title: '',
            icon: 'car',
            fuel: 0,
            fare: 0,
            tolls: 0,
            parking: 0,
            toFrom: '',
            timeToTravel: '',
            totalCost: 0,
            totalTime: '',
          },
        ],
      },
    ])
  }

  const handleAddQuestionInSubQuestion = (index: number) => {
    setFormData((prevFormData) => {
      const isRank = prevFormData[index].subquestions?.[0]?.type === 'rank'
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        subquestions: [
          ...updatedFormData[index].subquestions,
          {
            question: '',
            type: isRank ? 'rank' : 'text',
            required: false,
            other: false,
            options: isRank ? updatedFormData[index].subquestions?.[0]?.options : [''],
            comment: false,
            reason: false,
            reasonTitle: '',
            reasonType: 'text',
            reasonOptions: [''],
          },
        ],
        showSubQuestion: true,
      }
      return updatedFormData
    })
  }

  const updateOptions = (index: number, optionIndex: number, newOption: string) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        options: updatedFormData[index].options.map((item, i) => {
          if (i === optionIndex) {
            return newOption
          }
          return item
        }),
      }
      return updatedFormData
    })
  }

  const updatePreferenceOptions = (
    index: number,
    optionIndex: number,
    newOption: PreferenceOptions
  ) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        preferenceOptions: updatedFormData[index].preferenceOptions.map((item, i) => {
          if (i === optionIndex) {
            return newOption
          }
          return item
        }),
      }
      return updatedFormData
    })
  }

  const updateSectionOptions = (
    checkpointIndex: number,
    optionIndex: number,
    newOption: string
  ) => {
    setCheckpoints((prev) => {
      const updated = [...prev]
      const checkpoint = updated.find((cp) => cp.index === checkpointIndex)
      if (checkpoint) {
        checkpoint.sectionOptions[optionIndex] = {
          ...checkpoint.sectionOptions[optionIndex],
          option: newOption,
        }
      }
      return updated
    })
  }

  const updateSectionOptionsFromAndTo = (
    checkpointIndex: number,
    optionIndex: number,
    isFrom: boolean,
    value: number
  ) => {
    setCheckpoints((prev) => {
      const updated = [...prev]
      const checkpoint = updated.find((cp) => cp.index === checkpointIndex)
      if (checkpoint) {
        checkpoint.sectionOptions[optionIndex] = {
          ...checkpoint.sectionOptions[optionIndex],
          from: isFrom ? value : checkpoint.sectionOptions[optionIndex].from,
          to: !isFrom ? value : checkpoint.sectionOptions[optionIndex].to,
        }
      }
      return updated
    })
  }

  const updateReasonOptions = (index: number, optionIndex: number, newOption: string) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        reasonOptions: updatedFormData[index].reasonOptions.map((item, i) => {
          if (i === optionIndex) {
            return newOption
          }
          return item
        }),
      }
      return updatedFormData
    })
  }

  const updateSubQuestionOptions = (
    index: number,
    subquestionIndex: number,
    optionIndex: number,
    newOption: string
  ) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        subquestions: updatedFormData[index].subquestions.map((item, i) => {
          if (i === subquestionIndex || item.type === 'rank') {
            return {
              ...item,
              options: item.options.map((option, j) => {
                if (j === optionIndex) {
                  return newOption
                }
                return option
              }),
            }
          }
          return item
        }),
      }
      return updatedFormData
    })
  }

  const updateSubQuestionReasonOptions = (
    index: number,
    subquestionIndex: number,
    optionIndex: number,
    newOption: string
  ) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        subquestions: updatedFormData[index].subquestions.map((item, i) => {
          if (i === subquestionIndex || item.type === 'rank') {
            return {
              ...item,
              reasonOptions: item.reasonOptions.map((option, j) => {
                if (j === optionIndex) {
                  return newOption
                }
                return option
              }),
            }
          }
          return item
        }),
      }
      return updatedFormData
    })
  }

  const AddNewOption = (index: number) => {
    setFormData((prev) => {
      const updatedForm = prev.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            options: [...item.options, ''],
          }
        }
        return item
      })
      return updatedForm
    })
  }

  const AddNewPreferenceOption = (index: number) => {
    setFormData((prev) => {
      const updatedForm = prev.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            preferenceOptions: [
              ...item.preferenceOptions,
              {
                title: '',
                icon: 'car',
                fuel: 0,
                fare: 0,
                tolls: 0,
                parking: 0,
                toFrom: '',
                timeToTravel: '',
                totalCost: 0,
                totalTime: '',
              },
            ],
          }
        }
        return item
      })
      return updatedForm
    })
  }

  const addNewSectionOption = (checkpointIndex: number) => {
    setCheckpoints((prev) => {
      const updated = [...prev]
      const checkpoint = updated.find((cp) => cp.index === checkpointIndex)
      if (checkpoint) {
        checkpoint.sectionOptions.push({
          option: '',
          from: checkpointIndex + 2 > formData.length ? formData.length : checkpointIndex + 2,
          to: formData.length,
        })
      }
      return updated
    })
  }

  const AddNewReasonOption = (index: number) => {
    setFormData((prev) => {
      const updatedForm = prev.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            reasonOptions: [...item.reasonOptions, ''],
          }
        }
        return item
      })
      return updatedForm
    })
  }

  const AddNewSubQuestionOption = (index: number, elementIndex: number) => {
    setFormData((prev) => {
      const updatedForm = prev.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            subquestions: item.subquestions.map((subquestion, j) => {
              if (j === elementIndex || subquestion.type === 'rank') {
                return {
                  ...subquestion,
                  options: [...subquestion.options, ''],
                }
              }
              return subquestion
            }),
          }
        }
        return item
      })
      return updatedForm
    })
  }

  const AddNewSubQuestionReasonOption = (index: number, elementIndex: number) => {
    setFormData((prev) => {
      const updatedForm = prev.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            subquestions: item.subquestions.map((subquestion, j) => {
              if (j === elementIndex || subquestion.type === 'rank') {
                return {
                  ...subquestion,
                  reasonOptions: [...subquestion.reasonOptions, ''],
                }
              }
              return subquestion
            }),
          }
        }
        return item
      })
      return updatedForm
    })
  }

  const deleteOption = (index: number, optionIndex: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        options: updatedFormData[index].options.filter((_, i) => i !== optionIndex),
      }
      return updatedFormData
    })
  }

  const deletePreferenceOption = (index: number, optionIndex: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        preferenceOptions: updatedFormData[index].preferenceOptions.filter(
          (_, i) => i !== optionIndex
        ),
      }
      return updatedFormData
    })
  }

  const deleteSectionOption = (checkpointIndex: number, optionIndex: number) => {
    setCheckpoints((prev) => {
      const updated = [...prev]
      const checkpoint = updated.find((cp) => cp.index === checkpointIndex)
      if (checkpoint) {
        checkpoint.sectionOptions.splice(optionIndex, 1)
      }
      return updated
    })
  }

  const deleteReasonOption = (index: number, optionIndex: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        reasonOptions: updatedFormData[index].reasonOptions.filter((_, i) => i !== optionIndex),
      }
      return updatedFormData
    })
  }

  const deleteSubQuestionOption = (index: number, elementIndex: number, optionIndex: number) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        subquestions: updatedFormData[index].subquestions.map((subquestion, j) => {
          if (j === elementIndex || subquestion.type === 'rank') {
            return {
              ...subquestion,
              options: subquestion.options.filter((_, i) => i !== optionIndex),
            }
          }
          return subquestion
        }),
      }
      return updatedFormData
    })
  }

  const deleteSubQuestionReasonOption = (
    index: number,
    elementIndex: number,
    optionIndex: number
  ) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {
        ...updatedFormData[index],
        subquestions: updatedFormData[index].subquestions.map((subquestion, j) => {
          if (j === elementIndex || subquestion.type === 'rank') {
            return {
              ...subquestion,
              reasonOptions: subquestion.reasonOptions.filter((_, i) => i !== optionIndex),
            }
          }
          return subquestion
        }),
      }
      return updatedFormData
    })
  }

  const moveFeature = (index: number, direction: number) => {
    const prevFormData = [...formData]
    const newIndex = index + direction

    if (newIndex >= 0 && newIndex < prevFormData.length) {
      // Store original orders
      const orderA = prevFormData[index].order
      const orderB = prevFormData[newIndex].order

      // Swap elements
      const temp = prevFormData[index]
      prevFormData[index] = prevFormData[newIndex]
      prevFormData[newIndex] = temp

      // Update order for the first question and its subquestions
      prevFormData[index].order = orderA
      if (prevFormData[index].showSubQuestion && prevFormData[index].subquestions) {
        prevFormData[index].subquestions = prevFormData[index].subquestions.map((sq) => ({
          ...sq,
          order: orderA,
        }))
      }

      // Update order for the second question and its subquestions
      prevFormData[newIndex].order = orderB
      if (prevFormData[newIndex].showSubQuestion && prevFormData[newIndex].subquestions) {
        prevFormData[newIndex].subquestions = prevFormData[newIndex].subquestions.map((sq) => ({
          ...sq,
          order: orderB,
        }))
      }

      // Update checkpoint index if needed
      setCheckpoints((prevCheckpoints) => {
        return prevCheckpoints.map((cp) => {
          if (cp.index === index) {
            return {...cp, index: newIndex}
          } else if (cp.index === newIndex) {
            return {...cp, index: index}
          }
          return cp
        })
      })

      setFormData(prevFormData)
    }
  }

  const moveSubQuestionFeature = (index: number, elementIndex: number, direction: number) => {
    const prevFormData = [...formData]
    const newIndex = elementIndex + direction

    if (newIndex >= 0 && newIndex < prevFormData[index].subquestions.length) {
      // Swap elements
      const temp = prevFormData[index].subquestions[elementIndex]
      prevFormData[index].subquestions[elementIndex] = prevFormData[index].subquestions[newIndex]
      prevFormData[index].subquestions[newIndex] = temp

      setFormData(prevFormData)
    }
  }

  const handleAgentSelection = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value)
    setSelectedAgents(selectedOptions)
    setSelectedAgentValues(selectedValues)
  }

  const handleClientSelection = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value)
    setSelectedClients(selectedOptions)
    setSelectedClientValues(selectedValues)
  }

  const canAddCheckpoint = () => {
    return checkpoints.length < MAX_CHECKPOINTS
  }

  const getCheckpointData = (index: number) => {
    return checkpoints.find((cp) => cp.index === index)
  }

  return (
    <section>
      <div className='flex flex-col px-8 py-6'>
        <h3 className='mb-6 text-lg font-semibold'>Edit Interview</h3>
        <div className='w-full rounded-lg card p-4'>
          <form id='kt_modal_add_user_form' className='form' noValidate onSubmit={handleFormSubmit}>
            <h3 className='mb-6 text-base font-semibold'>Interview Name</h3>
            <input
              type='text'
              name='question'
              className='form-control form-control-solid mb-3 mb-lg-0'
              autoComplete='off'
              value={interviewData.interviewName}
              onChange={(e) => {
                setInterviewData((prev) => ({...prev, interviewName: e.target.value}))
              }}
            />
            <h3 className='my-6 text-base font-semibold'>Project Name</h3>
            {projectList.map((data, index) => {
              return (
                <div className='d-flex fv-row my-1' key={data._id}>
                  <div className='form-check form-check-custom form-check-solid'>
                    <input
                      type='radio'
                      name='project_name'
                      value={data._id}
                      id={`projectCheck${data._id}`}
                      className='form-check-input me-3'
                      checked={interviewData.project === data._id}
                      onChange={() => {
                        setGroupOption(data?.group?.map((item) => item))
                        setSurveyorList(index)
                        setInterviewData((prev) => ({...prev, project: data._id}))
                      }}
                    />
                    <label htmlFor={`projectCheck${data._id}`} className='form-check-label'>
                      {data.name}
                    </label>
                  </div>
                </div>
              )
            })}
            <h3 className='my-6 text-base font-semibold'>Group</h3>
            {groupOption && (
              <>
                <div className='my-1'>
                  {groupOption.map((option, index) => (
                    <div className='form-check form-check-custom form-check-solid mb-2' key={index}>
                      <input
                        type='radio'
                        name='group_option'
                        value={option}
                        className='form-check-input me-1'
                        onChange={(e) => {
                          setInterviewData((prev) => ({...prev, group: e.target.value}))
                        }}
                        checked={interviewData.group === option}
                      />
                      <label className='form-check-label'>{option}</label>
                    </div>
                  ))}
                </div>
              </>
            )}

            <div className='row'>
              <div className='col-lg-4'>
                <h3 className='my-6 text-base font-semibold'>Surveyors</h3>
                <Select
                  name='surveyors'
                  aria-label='Select a Surveyors'
                  placeholder='Select a Surveyors'
                  options={surveyorData[surveyorList]?.map((item) => ({
                    value: item?.fullName,
                    label: item?.fullName,
                  }))}
                  isMulti={true}
                  value={selectedAgents}
                  onChange={handleAgentSelection}
                />
              </div>

              <div className='col-lg-4'>
                <h3 className='my-6 text-base font-semibold'>Clients</h3>
                <Select
                  name='clients'
                  aria-label='Select Clients'
                  placeholder='Select Clients'
                  options={clientsData[surveyorList]?.map((item) => ({
                    value: item?.fullName,
                    label: item?.fullName,
                  }))}
                  isMulti={true}
                  value={selectedClients}
                  onChange={handleClientSelection}
                />
              </div>

              <div className='col-lg-4'>
                <h3 className='my-6 text-base font-semibold'>Questionnaire UI</h3>
                <Select
                  name='questionnaireUI'
                  aria-label='Select UI type'
                  placeholder='Select UI type'
                  options={[
                    {value: 'default', label: 'Default'},
                    {value: 'slide', label: 'Slide'},
                  ]}
                  value={
                    interviewData.questionnaireUI
                      ? {
                          value: interviewData.questionnaireUI,
                          label:
                            interviewData.questionnaireUI.charAt(0).toUpperCase() +
                            interviewData.questionnaireUI.slice(1),
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setInterviewData((prev) => ({
                      ...prev,
                      questionnaireUI: selectedOption?.value || '',
                    }))
                  }
                />
              </div>
            </div>

            <div className='mt-4'>
              {formData.map((data: any, index) => {
                const checkpointData = getCheckpointData(index)
                const isCheckpoint = data.type === 'checkpoint'

                return (
                  <div className='card mb-4' key={data?._id || index}>
                    <div className='card-body'>
                      <h3 className='text-base font-semibold card-title'>
                        Interview Question {index + 1}
                      </h3>
                      <div className='flex w-full items-center'>
                        <div className='flex items-center gap-2 p-2'>
                          <button
                            type='button'
                            onClick={() => moveFeature(index, -1)}
                            disabled={index === 0}
                            className='rounded-md bg-gray-200 p-1 text-gray-600 hover:bg-gray-300 disabled:opacity-50'
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-6 w-6'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z'
                                clipRule='evenodd'
                              />
                            </svg>
                          </button>
                          <button
                            type='button'
                            onClick={() => moveFeature(index, 1)}
                            disabled={index === formData.length - 1}
                            className='rounded-md bg-gray-200 p-1 text-gray-600 hover:bg-gray-300 disabled:opacity-50'
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-6 w-6'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                                clipRule='evenodd'
                              />
                            </svg>
                          </button>
                        </div>
                        {data.showSubQuestion ? (
                          <div className='flex-grow flex flex-col gap-3'>
                            <input
                              type='text'
                              className='form-control form-control-solid mb-3 mb-lg-0 flex-grow' // Add flex-grow to expand the input
                              placeholder='Title'
                              value={data.title}
                              onChange={(e) => handleInputChange(index, 'title', e.target.value)}
                              required
                            />
                            <input
                              type='text'
                              className='form-control form-control-solid mb-3 mb-lg-0 flex-grow'
                              placeholder='Title ID'
                              value={data.titleId}
                              onChange={(e) => handleInputChange(index, 'titleId', e.target.value)}
                            />
                          </div>
                        ) : (
                          <input
                            type='text'
                            className='form-control form-control-solid mb-3 mb-lg-0 flex-grow' // Add flex-grow to expand the input
                            placeholder='What is your question?'
                            value={data.question}
                            onChange={(e) => handleInputChange(index, 'question', e.target.value)}
                            required
                          />
                        )}
                        <button
                          className='rounded-lg bg-blue-300 p-2 md:ml-4'
                          type='button'
                          onClick={() => {
                            setFormData((prev) => {
                              const newData = [...prev]
                              const newItem = {
                                title: '',
                                titleId: '',
                                questionId: '',
                                order: prev.length,
                                question: '',
                                type: 'text',
                                required: false,
                                other: false,
                                options: [''],
                                comment: false,
                                subquestions: [],
                                showSubQuestion: false,
                                reason: false,
                                reasonTitle: '',
                                reasonId: '',
                                reasonType: 'text',
                                reasonOptions: [''],
                                checkpointId: null,
                                preferenceOptions: [
                                  {
                                    title: '',
                                    icon: 'car',
                                    fuel: 0,
                                    fare: 0,
                                    tolls: 0,
                                    parking: 0,
                                    toFrom: '',
                                    timeToTravel: '',
                                    totalCost: 0,
                                    totalTime: '',
                                  },
                                ],
                              }

                              // Insert new item right after current index
                              newData.splice(index + 1, 0, newItem)

                              // Reassign order for all following elements
                              const updatedData = newData.map((item, i) => ({
                                ...item,
                                order: i,
                              }))

                              return updatedData
                            })
                            setCheckpoints((prev) => {
                              return prev.map((cp) => {
                                if (cp.index > index) {
                                  return {...cp, index: cp.index + 1}
                                }
                                return cp
                              })
                            })
                          }}
                        >
                          <KTIcon iconName='plus' className='fs-3' />
                        </button>
                        <button
                          className='rounded-lg bg-yellow-300 p-2 md:ml-4'
                          type='button'
                          onClick={() => {
                            setFormData((prev) => {
                              const newData = [...prev]
                              const duplicatedItem = {
                                ...newData[index],
                                order: index + 1, // adjust order if needed
                                type:
                                  newData[index].type === 'checkpoint'
                                    ? 'checkbox'
                                    : newData[index].type,
                                checkpointId: null,
                              }

                              // Insert duplicated item right after current index
                              newData.splice(index + 1, 0, duplicatedItem)

                              // Reassign order for all following elements
                              const updatedData = newData.map((item, i) => ({
                                ...item,
                                order: i,
                              }))

                              return updatedData
                            })
                            setCheckpoints((prev) => {
                              return prev.map((cp) => {
                                if (cp.index > index) {
                                  return {...cp, index: cp.index + 1}
                                }
                                return cp
                              })
                            })
                          }}
                        >
                          <KTIcon iconName='copy' className='fs-3' />
                        </button>
                        <button
                          className='rounded-lg bg-red-300 p-2 md:ml-4'
                          type='button'
                          onClick={() =>
                            Swal.fire({
                              title: 'Are you sure?',
                              text: `You won't be able to revert this!`,
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: 'Yes, delete it!',
                              cancelButtonText: 'Cancel',
                            }).then((result) => {
                              if (result.isConfirmed) {
                                if (isCheckpoint) {
                                  setCheckpoints((prev) => prev.filter((cp) => cp.index !== index))
                                }

                                setCheckpoints((prev) => {
                                  return prev.map((cp) => {
                                    if (cp.index > index) {
                                      return {
                                        ...cp,
                                        index: cp.index - 1,
                                        sectionOptions: cp.sectionOptions.map((opt) => ({
                                          ...opt,
                                          from: opt.from > index ? opt.from - 1 : opt.from,
                                          to: opt.to > index ? opt.to - 1 : opt.to,
                                        })),
                                      }
                                    }
                                    return cp
                                  })
                                })

                                setFormData((prev) => prev.filter((_, idx) => idx !== index))
                              }
                            })
                          }
                        >
                          <KTIcon iconName='trash' className='fs-3' />
                        </button>
                      </div>
                      {data.showSubQuestion ? (
                        <>
                          {data.subquestions.map((subquestion, elementIndex) => {
                            return (
                              <Fragment key={elementIndex}>
                                <h4 className='text-base font-semibold card-title mt-4'>
                                  Sub Question {elementIndex + 1}
                                </h4>
                                <div className='flex w-full items-center'>
                                  <div className='flex items-center gap-2 p-2'>
                                    <button
                                      type='button'
                                      onClick={() =>
                                        moveSubQuestionFeature(index, elementIndex, -1)
                                      }
                                      disabled={elementIndex === 0}
                                      className='rounded-md bg-gray-200 p-1 text-gray-600 hover:bg-gray-300 disabled:opacity-50'
                                    >
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        className='h-6 w-6'
                                        viewBox='0 0 20 20'
                                        fill='currentColor'
                                      >
                                        <path
                                          fillRule='evenodd'
                                          d='M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z'
                                          clipRule='evenodd'
                                        />
                                      </svg>
                                    </button>
                                    <button
                                      type='button'
                                      onClick={() => moveSubQuestionFeature(index, elementIndex, 1)}
                                      disabled={
                                        elementIndex === formData[index].subquestions.length - 1
                                      }
                                      className='rounded-md bg-gray-200 p-1 text-gray-600 hover:bg-gray-300 disabled:opacity-50'
                                    >
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        className='h-6 w-6'
                                        viewBox='0 0 20 20'
                                        fill='currentColor'
                                      >
                                        <path
                                          fillRule='evenodd'
                                          d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                                          clipRule='evenodd'
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                  <input
                                    type='text'
                                    className='form-control form-control-solid mb-3 mb-lg-0 flex-grow' // Add flex-grow to expand the input
                                    placeholder='What is your question?'
                                    value={subquestion.question}
                                    onChange={(e) =>
                                      handleSubQuestionInputChange(
                                        index,
                                        elementIndex,
                                        'question',
                                        e.target.value
                                      )
                                    }
                                    required
                                  />

                                  <button
                                    className='rounded-lg bg-red-300 p-2 md:ml-4'
                                    type='button'
                                    onClick={() =>
                                      Swal.fire({
                                        title: 'Are you sure?',
                                        text: `You won't be able to revert this!`,
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'Yes, delete it!',
                                        cancelButtonText: 'Cancel',
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          setFormData((prev) => {
                                            const updatedFormData = [...prev]
                                            updatedFormData[index].subquestions = updatedFormData[
                                              index
                                            ].subquestions.filter((_, idx) => idx !== elementIndex)
                                            return updatedFormData
                                          })
                                        }
                                      })
                                    }
                                  >
                                    <KTIcon iconName='trash' className='fs-3' />
                                  </button>
                                </div>
                                <input
                                  type='text'
                                  className='form-control form-control-solid my-3 mb-lg-0 flex-grow'
                                  placeholder='Question ID'
                                  value={subquestion.questionId}
                                  onChange={(e) =>
                                    handleSubQuestionInputChange(
                                      index,
                                      elementIndex,
                                      'questionId',
                                      e.target.value
                                    )
                                  }
                                />
                                {(elementIndex === 0 ||
                                  data.subquestions?.[0]?.type !== 'rank') && (
                                  <div className='mx-4 my-6'>
                                    <h4 className='my-4 text-base font-semibold'>Field Type</h4>
                                    <select
                                      name=''
                                      id=''
                                      className='form-select form-select-sm form-select-solid'
                                      data-control='select2'
                                      data-placeholder='Latest'
                                      data-hide-search='true'
                                      onChange={(e) => {
                                        setFormData((prev) => {
                                          const updatedForm = [...prev]
                                          updatedForm[index] = {
                                            ...updatedForm[index],
                                            subquestions: updatedForm[index].subquestions.map(
                                              (subquestion, elemIdx) => {
                                                if (e.target.value === 'rank') {
                                                  return {
                                                    ...subquestion,
                                                    type: 'rank',
                                                    reason: false,
                                                  }
                                                }
                                                if (subquestion.type === 'rank') {
                                                  return {
                                                    ...subquestion,
                                                    type: e.target.value,
                                                  }
                                                }
                                                if (elemIdx === elementIndex) {
                                                  return {
                                                    ...subquestion,
                                                    type: e.target.value,
                                                  }
                                                }
                                                return subquestion
                                              }
                                            ),
                                          }
                                          return updatedForm
                                        })
                                      }}
                                      value={subquestion.type}
                                    >
                                      {elementIndex === 0 && <option value='rank'>Rank</option>}
                                      <option value='text'>Text</option>
                                      <option value='number'>Number</option>
                                      <option value='checkbox'>Checkboxes</option>
                                      <option value='multiple'>Multiple Choice</option>
                                      <option value='dropdown'>Dropdown</option>
                                      <option value='date'>Date</option>
                                      <option value='time'>Time</option>
                                      <option value='time-15'>Time Interval - 15mins</option>
                                      <option value='time-30'>Time Interval - 30mins</option>
                                      <option value='time-60'>Time Interval - 60mins</option>
                                      <option value='country'>Country</option>
                                      <option value='location'>Location</option>
                                    </select>
                                  </div>
                                )}
                                <div className=''>
                                  {subquestion.type === 'text' && <TextInput {...data} />}
                                  {(subquestion.type === 'checkbox' ||
                                    (subquestion.type === 'rank' && elementIndex === 0)) && (
                                    <CheckBoxesInput
                                      options={subquestion.options}
                                      updateOptions={(newOption, optionIndex) =>
                                        updateSubQuestionOptions(
                                          index,
                                          elementIndex,
                                          optionIndex,
                                          newOption
                                        )
                                      }
                                      AddNewOption={() =>
                                        AddNewSubQuestionOption(index, elementIndex)
                                      }
                                      deleteOption={(optionIndex) =>
                                        deleteSubQuestionOption(index, elementIndex, optionIndex)
                                      }
                                    />
                                  )}
                                  {subquestion.type === 'multiple' && (
                                    <MultipleChoiceInput
                                      options={subquestion.options}
                                      updateOptions={(newOption, optionIndex) =>
                                        updateSubQuestionOptions(
                                          index,
                                          elementIndex,
                                          optionIndex,
                                          newOption
                                        )
                                      }
                                      AddNewOption={() =>
                                        AddNewSubQuestionOption(index, elementIndex)
                                      }
                                      deleteOption={(optionIndex) =>
                                        deleteSubQuestionOption(index, elementIndex, optionIndex)
                                      }
                                    />
                                  )}
                                  {subquestion.type === 'dropdown' && (
                                    <DropdownInput
                                      options={subquestion.options}
                                      updateOptions={(newOption, optionIndex) =>
                                        updateSubQuestionOptions(
                                          index,
                                          elementIndex,
                                          optionIndex,
                                          newOption
                                        )
                                      }
                                      AddNewOption={() =>
                                        AddNewSubQuestionOption(index, elementIndex)
                                      }
                                      deleteOption={(optionIndex) =>
                                        deleteSubQuestionOption(index, elementIndex, optionIndex)
                                      }
                                    />
                                  )}
                                </div>
                                <div className='flex gap-4 mb-2'>
                                  <ToggleButton
                                    handleRequiredButton={() =>
                                      handleSubQuestionRequiredButton(index, elementIndex)
                                    }
                                    checked={subquestion.required}
                                    index={Number(String(index) + String(elementIndex))}
                                  />
                                  {subquestion.type !== 'text' && (
                                    <ToggleButton2
                                      handleOtherInputButton={() =>
                                        handleSubQuestionOtherInputButton(index, elementIndex)
                                      }
                                      checked={subquestion.other}
                                      index={Number(String(index) + String(elementIndex))}
                                    />
                                  )}
                                  <ToggleButton
                                    handleRequiredButton={() =>
                                      handleSubQuestionCommentRequiredButton(index, elementIndex)
                                    }
                                    index={Number(String(index) + String(elementIndex))}
                                    text='Add Comment'
                                    checked={subquestion.comment}
                                  />
                                  {subquestion.type !== 'rank' && (
                                    <ToggleButton
                                      handleRequiredButton={() =>
                                        handleSubQuestionReasonRequiredButton(index, elementIndex)
                                      }
                                      index={Number(String(index) + String(elementIndex))}
                                      text='Add Reason'
                                      checked={subquestion.reason}
                                    />
                                  )}
                                </div>

                                {subquestion.reason && (
                                  <>
                                    <div className='mx-4 my-6'>
                                      <div className='mb-4'>
                                        <h4 className='mb-4 text-base font-semibold'>
                                          Reason Title
                                        </h4>
                                        <input
                                          type='text'
                                          className='form-control form-control-solid'
                                          value={subquestion.reasonTitle}
                                          placeholder='Reason'
                                          onChange={(e) =>
                                            setFormData((prev) => {
                                              const updatedForm = [...prev]
                                              updatedForm[index] = {
                                                ...updatedForm[index],
                                                subquestions: updatedForm[index].subquestions.map(
                                                  (subquestion, elemIdx) => {
                                                    if (elemIdx === elementIndex) {
                                                      return {
                                                        ...subquestion,
                                                        reasonTitle: e.target.value,
                                                      }
                                                    }
                                                    return subquestion
                                                  }
                                                ),
                                              }
                                              return updatedForm
                                            })
                                          }
                                        />
                                      </div>
                                      <input
                                        type='text'
                                        className='form-control form-control-solid mb-3 mb-lg-0 flex-grow'
                                        placeholder='Question ID'
                                        value={subquestion.reasonId}
                                        onChange={(e) =>
                                          setFormData((prev) => {
                                            const updatedForm = [...prev]
                                            updatedForm[index] = {
                                              ...updatedForm[index],
                                              subquestions: updatedForm[index].subquestions.map(
                                                (subquestion, elemIdx) => {
                                                  if (elemIdx === elementIndex) {
                                                    return {
                                                      ...subquestion,
                                                      reasonId: e.target.value,
                                                    }
                                                  }
                                                  return subquestion
                                                }
                                              ),
                                            }
                                            return updatedForm
                                          })
                                        }
                                      />
                                      <h4 className='my-4 text-base font-semibold'>
                                        Reason Field Type
                                      </h4>
                                      <select
                                        name=''
                                        id=''
                                        className='form-select form-select-sm form-select-solid'
                                        data-control='select2'
                                        data-placeholder='Latest'
                                        data-hide-search='true'
                                        onChange={(e) => {
                                          setFormData((prev) => {
                                            const updatedForm = [...prev]
                                            updatedForm[index] = {
                                              ...updatedForm[index],
                                              subquestions: updatedForm[index].subquestions.map(
                                                (subquestion, elemIdx) => {
                                                  if (elemIdx === elementIndex) {
                                                    return {
                                                      ...subquestion,
                                                      reasonType: e.target.value,
                                                    }
                                                  }
                                                  return subquestion
                                                }
                                              ),
                                            }
                                            return updatedForm
                                          })
                                        }}
                                        value={subquestion.reasonType}
                                      >
                                        <option value='text'>Text</option>
                                        <option value='number'>Number</option>
                                        <option value='checkbox'>Checkboxes</option>
                                        <option value='multiple'>Multiple Choice</option>
                                        <option value='dropdown'>Dropdown</option>
                                        <option value='date'>Date</option>
                                        <option value='time'>Time</option>
                                        <option value='time-15'>Time Interval - 15mins</option>
                                        <option value='time-30'>Time Interval - 30mins</option>
                                        <option value='time-60'>Time Interval - 60mins</option>
                                        <option value='country'>Country</option>
                                        <option value='location'>Location</option>
                                      </select>
                                    </div>
                                    <div className=''>
                                      {subquestion.reasonType === 'text' && (
                                        <TextInput {...data} question='Reason' />
                                      )}
                                      {subquestion.reasonType === 'checkbox' && (
                                        <CheckBoxesInput
                                          options={subquestion.reasonOptions}
                                          updateOptions={(newOption, optionIndex) =>
                                            updateSubQuestionReasonOptions(
                                              index,
                                              elementIndex,
                                              optionIndex,
                                              newOption
                                            )
                                          }
                                          AddNewOption={() =>
                                            AddNewSubQuestionReasonOption(index, elementIndex)
                                          }
                                          deleteOption={(optionIndex) =>
                                            deleteSubQuestionReasonOption(
                                              index,
                                              elementIndex,
                                              optionIndex
                                            )
                                          }
                                        />
                                      )}
                                      {subquestion.reasonType === 'multiple' && (
                                        <MultipleChoiceInput
                                          options={subquestion.reasonOptions}
                                          updateOptions={(newOption, optionIndex) =>
                                            updateSubQuestionReasonOptions(
                                              index,
                                              elementIndex,
                                              optionIndex,
                                              newOption
                                            )
                                          }
                                          AddNewOption={() =>
                                            AddNewSubQuestionReasonOption(index, elementIndex)
                                          }
                                          deleteOption={(optionIndex) =>
                                            deleteSubQuestionReasonOption(
                                              index,
                                              elementIndex,
                                              optionIndex
                                            )
                                          }
                                        />
                                      )}
                                      {subquestion.reasonType === 'dropdown' && (
                                        <DropdownInput
                                          options={subquestion.reasonOptions}
                                          updateOptions={(newOption, optionIndex) =>
                                            updateSubQuestionReasonOptions(
                                              index,
                                              elementIndex,
                                              optionIndex,
                                              newOption
                                            )
                                          }
                                          AddNewOption={() =>
                                            AddNewSubQuestionReasonOption(index, elementIndex)
                                          }
                                          deleteOption={(optionIndex) =>
                                            deleteSubQuestionReasonOption(
                                              index,
                                              elementIndex,
                                              optionIndex
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                  </>
                                )}
                              </Fragment>
                            )
                          })}
                        </>
                      ) : (
                        <>
                          <div className='mx-4 my-6'>
                            <input
                              type='text'
                              className='form-control form-control-solid mb-3 mb-lg-0 flex-grow'
                              placeholder='Question ID'
                              value={data.questionId}
                              onChange={(e) =>
                                handleInputChange(index, 'questionId', e.target.value)
                              }
                            />
                            <h4 className='my-4 text-base font-semibold'>Field Type</h4>
                            <select
                              name=''
                              id=''
                              className='form-select form-select-sm form-select-solid'
                              data-control='select2'
                              data-placeholder='Latest'
                              data-hide-search='true'
                              onChange={(e) => {
                                const newType = e.target.value

                                setFormData((prev) => {
                                  const updatedFormData = prev.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        type: newType,
                                      }
                                    }
                                    return item
                                  })
                                  return updatedFormData
                                })
                                if (newType === 'checkpoint') {
                                  // Add new checkpoint
                                  setCheckpoints((prev) => [
                                    ...prev,
                                    {
                                      index: index,
                                      sectionOptions: [
                                        {
                                          option: '',
                                          from:
                                            index + 2 > formData.length
                                              ? formData.length
                                              : index + 2,
                                          to: formData.length,
                                        },
                                      ],
                                    },
                                  ])
                                } else if (data.type === 'checkpoint') {
                                  setCheckpoints((prev) => prev.filter((cp) => cp.index !== index))
                                }
                              }}
                              value={data.type}
                            >
                              <option value='text'>Text</option>
                              <option value='number'>Number</option>
                              {canAddCheckpoint() || isCheckpoint ? (
                                <option value='checkpoint'>Checkpoint</option>
                              ) : null}
                              <option value='checkbox'>Checkboxes</option>
                              <option value='multiple'>Multiple Choice</option>
                              <option value='dropdown'>Dropdown</option>
                              <option value='date'>Date</option>
                              <option value='time'>Time</option>
                              <option value='time-15'>Time Interval - 15mins</option>
                              <option value='time-30'>Time Interval - 30mins</option>
                              <option value='time-60'>Time Interval - 60mins</option>
                              <option value='country'>Country</option>
                              <option value='location'>Location</option>
                              <option value='preference'>Preference</option>
                            </select>
                          </div>
                          <div className=''>
                            {data.type === 'text' && <TextInput {...data} />}
                            {data.type === 'checkbox' && (
                              <CheckBoxesInput
                                options={data.options}
                                updateOptions={(newOption, optionIndex) =>
                                  updateOptions(index, optionIndex, newOption)
                                }
                                AddNewOption={() => AddNewOption(index)}
                                deleteOption={(optionIndex) => deleteOption(index, optionIndex)}
                              />
                            )}
                            {data.type === 'multiple' && (
                              <MultipleChoiceInput
                                options={data.options}
                                updateOptions={(newOption, optionIndex) =>
                                  updateOptions(index, optionIndex, newOption)
                                }
                                AddNewOption={() => AddNewOption(index)}
                                deleteOption={(optionIndex) => deleteOption(index, optionIndex)}
                              />
                            )}
                            {data.type === 'dropdown' && (
                              <DropdownInput
                                options={data.options}
                                updateOptions={(newOption, optionIndex) =>
                                  updateOptions(index, optionIndex, newOption)
                                }
                                AddNewOption={() => AddNewOption(index)}
                                deleteOption={(optionIndex) => deleteOption(index, optionIndex)}
                              />
                            )}
                            {data.type === 'checkpoint' && checkpointData && (
                              <MultipleChoiceSectionInput
                                sectionOptions={checkpointData.sectionOptions}
                                updateSectionOptions={(newOption, optionIndex) => {
                                  updateSectionOptions(index, optionIndex, newOption)
                                }}
                                updateSectionFrom={(newFrom, optionIndex) => {
                                  updateSectionOptionsFromAndTo(index, optionIndex, true, newFrom)
                                }}
                                updateSectionTo={(newTo, optionIndex) => {
                                  updateSectionOptionsFromAndTo(index, optionIndex, false, newTo)
                                }}
                                addNewSectionOption={() => addNewSectionOption(index)}
                                deleteSectionOption={(optionIndex) => {
                                  deleteSectionOption(index, optionIndex)
                                }}
                                availableQuestionStart={
                                  index + 2 > formData.length ? formData.length : index + 2
                                }
                                availableQuestionEnd={formData.length}
                              />
                            )}
                            {data.type === 'preference' && (
                              <PreferenceInput
                                preferenceOptions={data?.preferenceOptions}
                                updatePreferenceOptions={(
                                  optionData: PreferenceOptions,
                                  optionIndex
                                ) => {
                                  updatePreferenceOptions(index, optionIndex, optionData)
                                }}
                                AddNewOption={() => AddNewPreferenceOption(index)}
                                deleteOption={(optionIndex) =>
                                  deletePreferenceOption(index, optionIndex)
                                }
                              />
                            )}
                          </div>
                        </>
                      )}
                      <div className='flex gap-4'>
                        {!data.showSubQuestion && (
                          <>
                            <ToggleButton
                              handleRequiredButton={() => handleRequiredButton(index)}
                              index={index}
                              checked={data.required}
                            />
                            {data.type !== 'text' && (
                              <ToggleButton2
                                handleOtherInputButton={() => handleOtherInputButton(index)}
                                index={index}
                                checked={data.other}
                              />
                            )}
                            <ToggleButton
                              handleRequiredButton={() => handleCommentRequiredButton(index)}
                              index={index}
                              text='Add Comment'
                              checked={data.comment}
                            />
                            <ToggleButton
                              handleRequiredButton={() => handleReasonRequiredButton(index)}
                              index={index}
                              text='Add Reason'
                              checked={data.reason}
                            />
                          </>
                        )}

                        {!data.showSubQuestion ? (
                          <div className='ms-auto'>
                            <ToggleButton
                              handleRequiredButton={() => handleAddSubQuestion(index)}
                              index={index}
                              text='Add Sub Question'
                            />
                          </div>
                        ) : (
                          <div className='ms-auto'>
                            <button
                              className='btn btn-icon btn-warning'
                              type='button'
                              onClick={() => handleAddQuestionInSubQuestion(index)}
                            >
                              <KTIcon iconName='plus' className='fs-3' />
                            </button>
                          </div>
                        )}
                      </div>
                      {data.reason && (
                        <>
                          <div className='mx-4 my-6'>
                            <div className='mb-4'>
                              <h4 className='mb-4 text-base font-semibold'>Reason Title</h4>
                              <input
                                type='text'
                                className='form-control form-control-solid'
                                value={data.reasonTitle}
                                placeholder='Reason'
                                onChange={(e) =>
                                  setFormData((prev) => {
                                    const updatedFormData = prev.map((item, i) => {
                                      if (i === index) {
                                        return {
                                          ...item,
                                          reasonTitle: e.target.value,
                                        }
                                      }
                                      return item
                                    })
                                    return updatedFormData
                                  })
                                }
                              />
                            </div>
                            <input
                              type='text'
                              className='form-control form-control-solid mb-3 mb-lg-0 flex-grow'
                              placeholder='Reason ID'
                              value={data.reasonId}
                              onChange={(e) =>
                                setFormData((prev) => {
                                  const updatedFormData = prev.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        reasonId: e.target.value,
                                      }
                                    }
                                    return item
                                  })
                                  return updatedFormData
                                })
                              }
                            />
                            <h4 className='my-4 text-base font-semibold'>Reason Field Type</h4>
                            <select
                              name=''
                              id=''
                              className='form-select form-select-sm form-select-solid'
                              data-control='select2'
                              data-placeholder='Latest'
                              data-hide-search='true'
                              onChange={(e) => {
                                setFormData((prev) => {
                                  const updatedFormData = prev.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        reasonType: e.target.value,
                                      }
                                    }
                                    return item
                                  })
                                  return updatedFormData
                                })
                              }}
                              value={data.reasonType}
                            >
                              <option value='text'>Text</option>
                              <option value='number'>Number</option>
                              <option value='checkbox'>Checkboxes</option>
                              <option value='multiple'>Multiple Choice</option>
                              <option value='dropdown'>Dropdown</option>
                              <option value='date'>Date</option>
                              <option value='time'>Time</option>
                              <option value='time-15'>Time Interval - 15mins</option>
                              <option value='time-30'>Time Interval - 30mins</option>
                              <option value='time-60'>Time Interval - 60mins</option>
                              <option value='country'>Country</option>
                              <option value='location'>Location</option>
                            </select>
                          </div>
                          <div className=''>
                            {data.reasonType === 'text' && (
                              <TextInput {...data} question='Reason' />
                            )}
                            {data.reasonType === 'checkbox' && (
                              <CheckBoxesInput
                                options={data.reasonOptions}
                                updateOptions={(newOption, optionIndex) =>
                                  updateReasonOptions(index, optionIndex, newOption)
                                }
                                AddNewOption={() => AddNewReasonOption(index)}
                                deleteOption={(optionIndex) =>
                                  deleteReasonOption(index, optionIndex)
                                }
                              />
                            )}
                            {data.reasonType === 'multiple' && (
                              <MultipleChoiceInput
                                options={data.reasonOptions}
                                updateOptions={(newOption, optionIndex) =>
                                  updateReasonOptions(index, optionIndex, newOption)
                                }
                                AddNewOption={() => AddNewReasonOption(index)}
                                deleteOption={(optionIndex) =>
                                  deleteReasonOption(index, optionIndex)
                                }
                              />
                            )}
                            {data.reasonType === 'dropdown' && (
                              <DropdownInput
                                options={data.reasonOptions}
                                updateOptions={(newOption, optionIndex) =>
                                  updateReasonOptions(index, optionIndex, newOption)
                                }
                                AddNewOption={() => AddNewReasonOption(index)}
                                deleteOption={(optionIndex) =>
                                  deleteReasonOption(index, optionIndex)
                                }
                              />
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
            <div className='mx-auto my-6 flex items-center justify-center'>
              <button type='button' className='btn btn-secondary' onClick={handleAddQuestion}>
                Add Question
              </button>
            </div>
            <div className='mx-auto my-6 md:ml-8'>
              <button className='btn btn-warning' type='submit'>
                Edit Interview
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}

export default InterviewEditForm
